import {
  Box,
  CrudMode,
  DataDisplay,
  Grid,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input, Select } from "components";
import { College, CollegeEditResource, CollegeViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import ApiService from "services/apiService";

export const CollegePageBody = (props: {
  crudMode: CrudMode;
  college: College;
  setCollege: (value: College) => void;
  viewResource: CollegeViewResource;
  editResource: CollegeEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<College>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.college.name}</DataDisplay>
    ) : (
      <Select
        freeSolo
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        inputValue={props.college.name}
        fetchFunction={(searchString: string) => ApiService.search.ipeds(searchString)}
        getOptionLabel={(option) => `${option.unitId}: ${option.name}`}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            <Stack width="100%">
              <Typography variant="inherit">{option.name}</Typography>
              <Typography variant="caption" lineHeight={"100%"}>
                {option.unitId}
              </Typography>
            </Stack>
          </Box>
        )}
        onChange={(e, value) =>
          props.setCollege(
            produce(props.college, (draft) => {
              draft.name = value.name;
              draft.ipeds = value.unitId;
            })
          )
        }
        onInputChange={(e) =>
          props.setCollege(
            produce(props.college, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  const ipedsField = () => {
    const propertyName = pn<College>("ipeds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.college.ipeds}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.college.ipeds}
        onChange={(e) =>
          props.setCollege(
            produce(props.college, (draft) => {
              draft.ipeds = e.target.value as unknown as number;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {nameField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {ipedsField()}
      </Grid>
    </Grid>
  );
};
